import * as React from 'react';

import { translate } from '~l10n/client';

import { ContactSalesEventAdapter } from '~analytics/adapters/ContactSalesEventAdapter';
import { UITextButton } from '~shared/components/buttons';
import { useTypeFormLink } from '~teacher/components/PricingTable/hooks';

export function ContactSalesLinkButton({ onClick }: { onClick: () => void }) {
  const typeFormLink = useTypeFormLink();

  return (
    <UITextButton
      href={typeFormLink.data}
      appearance="primary"
      target="_blank"
      rel="noreferrer noopener"
      className="w-fit flex justify-center"
      onClick={() => {
        new ContactSalesEventAdapter({
          form_source: 'typeform',
        }).sendAnalytics();
        onClick();
      }}
    >
      {translate('Contact Sales')}
    </UITextButton>
  );
}
